import BasePerimeter from '@/kindergarten/perimeters/BasePerimiter';

export default new BasePerimeter({
  purpose: 'trading_role',

  can: {
    route() {
      return this.child && (this.isAdmin() || this.isTrading() || this.isAgentRole());
    },
  },
});



// WEBPACK FOOTER //
// ./src/kindergarten/perimeters/TradingPerimeter.js